module.exports = __webpack_public_path__ + "img/file-type-pdf-alt.683cd047.svg";